import React, { memo, useCallback } from "react";
import { TablePagination as MUITablePagination } from "@mui/material";
import useTableCtx from "../tableContext/useTableCtx";

const TablePagination = memo(
  ({ totalItems }: { totalItems: number | undefined }) => {
    const { tablePagination, handleSetTablePagination } = useTableCtx()!;

    const handleChangePage = useCallback(
      (_: unknown, newPage: number) => {
        handleSetTablePagination((prev) => ({
          ...prev,
          page: newPage + 1,
        }));
      },
      [handleSetTablePagination],
    );

    const handleChangeRowsPerPage = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        handleSetTablePagination((prev) => ({
          ...prev,
          rowsPerPage: parseInt(event.target.value, 10),
        }));
      },
      [handleSetTablePagination],
    );

    return (
      <MUITablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={totalItems ?? 1}
        rowsPerPage={tablePagination.rowsPerPage}
        page={tablePagination.page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={<span className="mb-0">Randuri:</span>}
        labelDisplayedRows={({ page }: { page: number }) => (
          <span className="mb-0">Pagina: {page + 1}</span>
        )}
        backIconButtonProps={{ color: "primary" }}
        nextIconButtonProps={{ color: "primary" }}
        SelectProps={{
          inputProps: {
            "aria-label": "page number",
          },
        }}
        showFirstButton={true}
        showLastButton={true}
      />
    );
  },
);

export default TablePagination;
